<template>
    <div class="agent-rating">
        <div class="d-flex align-items-center justify-content-between mb-3">
            <h5 class="mb-0">🏆 Рейтинг агентов</h5>
            <span class="rating-subtitle">Маржинальная<br />прибыль</span>
        </div>
        
        <div v-if="loading" class="text-center py-3">
            <i class="fas fa-spinner fa-spin"></i>
        </div>
        
        <div v-else class="rating-list">
            <!-- Топ агенты -->
                         <div 
                 v-for="(agent, index) in displayAgents" 
                 :key="agent.id" 
                 class="rating-item"
                 :class="{ 
                     'current-user': agent.isCurrentUser,
                     'dots-item': agent.isDots 
                 }"
             >
                 <div class="rating-position">
                     <span class="position-number" :class="getRankColor(index)">
                         {{ agent.position }}
                     </span>
                 </div>
                 
                 <div class="agent-info">
                     <div class="agent-details">
                         <div class="agent-name">
                             {{ agent.name }}
                             <span v-if="agent.isCurrentUser" class="current-user-badge">Вы</span>
                         </div>
                         <div class="agent-region" v-if="!agent.isDots && agent.region">
                             {{ agent.region }}
                         </div>
                     </div>
                     <div class="agent-margin" v-if="!agent.isDots">
                         <div class="agent-margin-value">
                             {{ formatPoints(agent.margin) }}
                         </div>
                         <div 
                             v-if="showChange(agent)" 
                             class="agent-margin-change" 
                             :class="trendClass(agent.trend)"
                         >
                             <i :class="trendIcon(agent.trend)" aria-hidden="true"></i>
                             <span>{{ formatChange(agent.marginChange) }}</span>
                         </div>
                     </div>
                 </div>
             </div>
            

            
            <!-- Информация о рейтинге -->
            <div class="rating-info mt-3">
                <p class="rating-info-text">
                    <i class="fas fa-info-circle me-1"></i>
                    Рейтинг обновляется автоматически каждую неделю, исходные рубли сохраняются без изменений
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { API_AGENT_RATING } from '@/constants';

export default {
    name: 'AgentRating',
    data() {
        return {
            loading: true,
            displayAgents: []
        };
    },
    computed: {
        ...mapGetters('auth', ['currentUser'])
    },
    mounted() {
        this.loadRating();
    },
    methods: {
        async loadRating() {
            try {
                this.loading = true;
                const response = await api.call('get', API_AGENT_RATING);
                
                if (response.data.success) {
                    this.displayAgents = response.data.data.agents;
                } else {
                    console.error('Ошибка загрузки рейтинга:', response.data.message);
                }
            } catch (error) {
                console.error('Ошибка загрузки рейтинга агентов:', error);
            } finally {
                this.loading = false;
            }
        },

        formatPoints(value) {
            const formatted = new Intl.NumberFormat('ru-RU', {
                style: 'currency',
                currency: 'RUB',
                maximumFractionDigits: 0
            }).format(Number(value || 0));

            return formatted;
        },

        formatChange(value) {
            const numericValue = Number(value || 0);
            const prefix = numericValue > 0 ? '+' : '';

            const formatted = new Intl.NumberFormat('ru-RU', {
                style: 'currency',
                currency: 'RUB',
                maximumFractionDigits: 0
            }).format(numericValue);

            return `${prefix}${formatted}`;
        },

        showChange(agent) {
            return agent && !agent.isDots && Number(agent.marginChange || 0) !== 0;
        },

        trendClass(trend) {
            if (trend === 'up') return 'trend-up';
            if (trend === 'down') return 'trend-down';
            return 'trend-neutral';
        },

        trendIcon(trend) {
            if (trend === 'up') return 'fas fa-arrow-up';
            if (trend === 'down') return 'fas fa-arrow-down';
            return 'fas fa-minus';
        },

        getRankColor(index) {
            // Цвета для медалей: золото, серебро, бронза
            if (index === 0) return 'text-warning'; // Золото
            if (index === 1) return 'text-secondary'; // Серебро  
            if (index === 2) return 'text-danger'; // Бронза
            return 'text-dark'; // Остальные черным
        },


    }
};
</script>

<style scoped>
.agent-rating {
    height: 100%;
}

.rating-subtitle {
    font-size: 0.85rem;
    color: #6c757d;
    font-weight: 500;
    line-height: 0.85rem;
    text-align: right;
    padding-right: 10px;
}

.rating-list {
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
}

.rating-item {
    display: flex;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #f8f9fa;
    transition: background-color 0.2s ease;
}

.rating-item:hover {
    background-color: #f8f9fa;
    border-radius: 6px;
    padding-left: 8px;
    padding-right: 8px;
    margin-left: -8px;
    margin-right: -8px;
}

.rating-item.current-user {
    background: linear-gradient(135deg, rgba(13, 99, 72, 0.1) 0%, rgba(227, 121, 38, 0.1) 100%);
    border-radius: 8px;
    padding: 12px 8px;
    margin: 4px -8px;
    border: 2px solid rgba(13, 99, 72, 0.2);
}

.rating-item.dots-item {
    justify-content: center;
    padding: 4px 0;
    border-bottom: none;
}

.rating-item.dots-item .agent-name {
    color: #6c757d;
    font-size: 1.2rem;
    font-weight: 400;
}

.rating-position {
    width: 40px;
    text-align: center;
    margin-right: 12px;
}

.position-number {
    font-weight: 700;
    font-size: 1.1rem;
    min-width: 24px;
    display: inline-block;
}

/* Специальные стили для медалей */
.position-number.text-warning {
    color: #FFD700 !important; /* Золото */
    text-shadow: 0 0 3px rgba(255, 215, 0, 0.3);
}

.position-number.text-secondary {
    color: #C0C0C0 !important; /* Серебро */
    text-shadow: 0 0 3px rgba(192, 192, 192, 0.3);
}

.position-number.text-danger {
    color: #CD7F32 !important; /* Бронза */
    text-shadow: 0 0 3px rgba(205, 127, 50, 0.3);
}

.agent-info {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.agent-details {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.agent-name {
    font-weight: 500;
    color: #2c3e50;
    display: flex;
    align-items: center;
    gap: 8px;
}

.agent-region {
    font-size: 0.75rem;
    color: #6c757d;
    font-weight: 400;
}

.current-user-badge {
    background: linear-gradient(135deg, #0d6348 0%, #e37926 100%);
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
}

.agent-margin {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    padding-right: 10px;
}

.agent-margin-value {
    font-weight: 600;
    color: #28a745;
    font-size: 0.95rem;
}

.agent-margin-change {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 0.75rem;
    font-weight: 600;
}

.agent-margin-change i {
    font-size: 0.7rem;
}

.agent-margin-change.trend-up {
    color: #28a745;
}

.agent-margin-change.trend-down {
    color: #dc3545;
}

.agent-margin-change.trend-neutral {
    color: #6c757d;
}

/* Стили для скроллбара */
.rating-list::-webkit-scrollbar {
    width: 6px;
}

.rating-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.rating-list::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.rating-list::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* Анимации */
.rating-item {
    animation: fadeInUp 0.3s ease-out;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Информация о рейтинге */
.rating-info {
    border-top: 1px solid #e9ecef;
    padding-top: 12px;
}

.rating-info-text {
    font-size: 0.75rem;
    color: #6c757d;
    font-style: italic;
    margin: 0;
    text-align: center;
    line-height: 1.3;
}

.rating-info-text i {
    font-size: 0.7rem;
    opacity: 0.7;
}

/* Адаптивность */
@media (max-width: 768px) {
    .agent-info {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
    }
    
    .agent-details {
        gap: 1px;
    }
    
    .agent-region {
        font-size: 0.7rem;
    }
    
    .agent-margin {
        font-size: 0.9rem;
    }
    
    .rating-info-text {
        font-size: 0.7rem;
    }
}
</style>
